import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { toast } from 'react-toastify';
import { fetchProfile, saveSettingsProfile, updateUserPassword } from 'src/redux/actions/profile.action';
import {
  fetchCompanyForUser,
  fetchTeamRoster,
  inviteTeamMember,
  removeTeamMember,
  revokeTeamInvite,
  setProductEnabled,
  updateMemberRole,
} from 'src/redux/actions/company.action';
import SettingsView from '../nurturer-platform/views/SettingsView';

const toastOptions = {
  position: 'bottom-right',
  autoClose: 2000,
};

function SettingsApp() {
  const dispatch = useDispatch();
  const { isAuth, user } = useSelector((state) => state.login);
  const { profileData } = useSelector((state) => state.profile);
  const { company, members, pendingInvites } = useSelector((state) => state.company || {});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (user?.uid) {
      dispatch(fetchProfile());
      dispatch(fetchCompanyForUser(user));
      dispatch(fetchTeamRoster(user));
    }
  }, [dispatch, user?.uid, user?.companyID, user?.companyId]);

  const handleSaveProfile = async (payload) => {
    setSaving(true);
    const result = await dispatch(saveSettingsProfile(payload, user));
    setSaving(false);
    if (result?.ok) {
      toast.success('Profile saved', toastOptions);
    } else {
      toast.error(result?.error || 'Could not save profile', toastOptions);
    }
  };

  const handleUpdatePassword = (password, confirmPassword) => {
    if (!password || password !== confirmPassword) {
      toast.error('Passwords do not match', toastOptions);
      return;
    }
    if (password.length < 6) {
      toast.error('Password must be at least 6 characters', toastOptions);
      return;
    }
    dispatch(updateUserPassword({ password }, user.uid));
  };

  if (!isAuth) {
    return <Redirect to="/login" />;
  }

  return (
    <SettingsView
      user={user}
      profile={profileData || {}}
      company={company}
      members={members}
      pendingInvites={pendingInvites}
      saving={saving}
      onSaveProfile={handleSaveProfile}
      onUpdatePassword={handleUpdatePassword}
      onInviteMember={(payload) => dispatch(inviteTeamMember(payload, user))}
      onUpdateMemberRole={(memberId, role) =>
        dispatch(updateMemberRole(memberId, role, user))
      }
      onRemoveMember={(memberId) => dispatch(removeTeamMember(memberId, user))}
      onRevokeInvite={(inviteId) => dispatch(revokeTeamInvite(inviteId, user))}
      onToggleProduct={(productId, enabled) =>
        dispatch(setProductEnabled(productId, enabled, user))
      }
    />
  );
}

export default SettingsApp;
